import { render, staticRenderFns } from "./CReportRow.vue?vue&type=template&id=2bb279d4&scoped=true&"
import script from "./CReportRow.vue?vue&type=script&lang=js&"
export * from "./CReportRow.vue?vue&type=script&lang=js&"
import style0 from "./CReportRow.vue?vue&type=style&index=0&id=2bb279d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb279d4",
  null
  
)

export default component.exports